import { getKxgcToPathNameMap } from '../kxgc';
import { scheduleToPathNameMap } from '../schedule';
import { psiToPathNameMap, scmToPathNameMap, scmOtherToPathNameMap, // 能动态获取基础路由前缀再开放
 } from '../scm';
import { uimsToPathNameMap } from '../uims/getUimsToPathName';
import { getOssToPathNameMap } from '../oss';
import { getCuToPathNameMap } from '../cu';
import { getGovToPathNameMap } from '../gov';
import { getJgToPathNameMap } from '../jg';
export const summaryMap = (function () {
    let fromPartnerPathNameMap = {};
    // 根据环境区分，解决businessKey重复问题
    switch (process.env['DEPLOY_TYPE']) {
        case 'cu':
            fromPartnerPathNameMap = {
                ...getCuToPathNameMap,
            };
            break;
    }
    // console.log('fromPartnerPathNameMap', fromPartnerPathNameMap);
    return {
        ...scmToPathNameMap,
        ...psiToPathNameMap,
        ...scmOtherToPathNameMap,
        ...uimsToPathNameMap,
        ...scheduleToPathNameMap,
        ...getKxgcToPathNameMap,
        ...getOssToPathNameMap,
        ...fromPartnerPathNameMap,
        ...getGovToPathNameMap,
        ...getJgToPathNameMap,
    };
})();
